var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLauncher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2.256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.64,
    cy: 10.64,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 10.64,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.36,
    cy: 10.64,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.64,
    cy: 24,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 24,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.36,
    cy: 24,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.64,
    cy: 37.36,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24,
    cy: 37.36,
    r: 5.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.36,
    cy: 37.36,
    r: 5.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauncher);
export default __webpack_public_path__ + "static/media/launcher.5a1102d36f0ca5024cda41ff3c1af4bd.svg";
export { ForwardRef as ReactComponent };